import React from 'react';

interface ModalBackButtonProps {
  onClick: () => void;
  ariaLabel?: string;
  direction?: 'back' | 'forward';
  className?: string;
}

/** Circle chevron for info modals (back) and the print-event banner (forward). */
function ModalBackButton({
  onClick,
  ariaLabel,
  direction = 'back',
  className,
}: ModalBackButtonProps): React.ReactElement {
  const label = ariaLabel ?? (direction === 'forward' ? 'Forward' : 'Back');
  const path = direction === 'forward' ? 'M9 5 L16 12 L9 19' : 'M15 5 L8 12 L15 19';
  const classes = ['pbl-modal-back', direction === 'forward' ? 'pbl-modal-back-forward' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type="button" className={classes} onClick={onClick} aria-label={label}>
      <svg
        className="pbl-modal-back-icon"
        viewBox="0 0 24 24"
        width="18"
        height="18"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d={path}
          fill="none"
          stroke="currentColor"
          strokeWidth="3.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}

export default ModalBackButton;
